/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Preset_7dInputs */

const vi_report_preset_7d = /** @type {(inputs: Report_Preset_7dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 ngày`)
};

/**

* @param {Report_Preset_7dInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_preset_7d = /** @type {((inputs?: Report_Preset_7dInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Preset_7dInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_preset_7d(inputs)
});